export class IDLE {
    Type: string = "IDLE";
    SerialNumber:string;
    Status: boolean;
    StartDate: Date;
    EndDate: Date;
    Duration: number;
}